import React from "react"
import {connect} from "react-redux"
import {Field, getFormValues, reduxForm, change , SubmissionError } from "redux-form"
import { TextInput , SubmitButton , AnalyticEvent , DirectCall } from "../components/forms";
import {CountryListSelectMenu} from "../components/forms/countrylist-selectmenu";
import {UserProfile} from "../api/user-profile";
import {UserRegistration} from "../api/user-registration";
import {Errors, flattenObject} from "../api/util";
import { HashLink as Link } from 'react-router-hash-link';
import Validators from "../validation"
import scrollIntoViewIfNeeded from "scroll-into-view-if-needed/dist/index";
import ReactDOM from "react-dom";

let GetComponent = (props) => {

    return (
        <div>

            <form data-form-component={"registered-account-get"} className="row widget-form" onSubmit={props.handleSubmit} >
                <section>
                    <h5>Set up your account similar to a colleagues.</h5>
                    <p>If you would like the same functionality and access as someone at your work, let us know their username and we will set you up</p>
                    <Field id="colleague.username" name="colleague.username" placeholder="e.g. JohnFysh" title="Colleagues username" component={TextInput}/>
                    <h3>Let us know your company details</h3>
                    <Field id="name" name="name" placeholder="" title="Company name" component={TextInput}/>
                    <Field id="streetaddress" name="streetaddress" maxlength="50" placeholder="" title="Street address" component={TextInput}/>
                    <Field id="city" name="city" placeholder="" title="City" component={TextInput}/>
                    <Field id="state" name="state" placeholder="" title="State" component={TextInput}/>
                    <Field id="postcode" name="postcode" placeholder="" title="Postcode" component={TextInput}/>
                    <CountryListSelectMenu title="Country/Territory"/>
                    <SubmitButton label="FIND COLLEAGUES DETAILS"/>
                </section>
            </form>
            <section className="row">
                <a className="internal-link" onClick={props.redirectToNoAccount}>I don't know any username's</a>
            </section>
        </div>
    )
};

class ScrollToGetComponent extends React.Component {

    static Internal = class extends React.Component {
        render = () => {
            return <GetComponent {...this.props}/>
        }
    };

    componentDidMount = () => {
        if(this._sivNode)
            scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._sivNode), false , {duration: 150});
    };

    render = () => {
        return <ScrollToGetComponent.Internal {...this.props}  ref={(node) => { this._sivNode = node}}/>
    }

}

GetComponent = reduxForm({form: 'existingcompany' , destroyOnUnmount: false ,
    asyncBlurFields: ['colleague.username' , 'name' , 'streetaddress' , 'city' , 'state' , 'postcode'],
    asyncValidate : (values , dispatch, props , blurredField) => {
        return new Promise((resolve,reject) => {
            if(blurredField === "colleague.username"){
                UserProfile(props.config.userprof).user(values.colleague.username).Summary.Get()
                    .then(
                        (response) => {
                            dispatch(change('existingcompany', 'colleague', response.data));
                            resolve({});
                        },
                        (reason) => {
                            if(reason.status >= 500 || reason.status === 0){
                                reject( {"username": {"message": "Not validated"}});
                                dispatch(Errors.TechnicalError());
                            }
                            else{
                                const error = { colleague : {
                                    username : { message : reason.message}
                                }};
                                reject(error);

                            }
                        })
            }
            else{
                resolve({})
            }
        })
    }
})(GetComponent);
GetComponent = connect(state => {
    let registration = getFormValues('registration')(state);
    let company = getFormValues('existingcompany')(state);

    return {
        config : getFormValues('config')(state),
        company : getFormValues('existingcompany')(state),
        registration : {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "COLLEAGUE",
            "colleague": {
                "companyName": company.name,
                "username": company.colleague.username,
                "streetAddress": company.streetaddress,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": company.country.value,
                "countryName": company.country.label
            }
        }
    }
})(GetComponent);

let ViewComponent = (props) => {

    return (
    <div>
            <form className="row widget-form" onSubmit={props.handleSubmit} >
                <section className="lookup-section">
                    <h5>Would you like to copy these colleagues details for your setup?</h5>
                    <div className="card-item">
                        <div className="card">
                            <h5 id="colleagueName">
                                {props.company.colleague.firstName} {props.company.colleague.lastName}
                            </h5>
                            <p className="code-text">Username {props.company.colleague.username}</p>
                        </div>
                    </div>

                    <div className="card-item">
                        <div className="card">
                            <h5 className="card__heading">{props.company.name}</h5>
                            <div className="card-details-text">{props.company.streetaddress}</div>
                            <div className="card-details-text">{props.company.city}</div>
                            <div className="card-details-text">{props.company.state}</div>
                            <div className="card-details-text">{props.company.postcode}</div>
                            <div className="card-details-text">{props.company.country.label}</div>
                        </div>
                    </div>
                    <SubmitButton label="YES COPY THESE DETAILS" />

                </section>

            </form>
            <section className={"row"}>
                <a className="internal-link" onClick={props.back}>Look up another username</a>
            </section>
        </div>
    )
};

class ScrollToViewComponent extends React.Component {

    static Internal = class extends React.Component {
        render = () => {
            return <ViewComponent {...this.props}/>
        }
    };

    componentDidMount = () => {
        if(this._sivNode)
            scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._sivNode), false , {duration: 150});
    };

    render = () => {
        return <ScrollToViewComponent.Internal {...this.props}  ref={(node) => { this._sivNode = node}}/>
    }
}

ViewComponent = connect((state) => {

    let registration = getFormValues('registration')(state);
    let company = getFormValues('existingcompany')(state);

    return {
        config : getFormValues('config')(state),
        company : getFormValues('existingcompany')(state),
        registration : {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "COLLEAGUE",
            "colleague": {
                "companyName": company.name,
                "username": company.colleague.username,
                "streetAddress": company.streetaddress,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": company.country.value,
                "countryName": company.country.label
            }

        }
    }

})(reduxForm({form: 'existingcompany' , destroyOnUnmount: false})(ViewComponent));

ViewComponent.defaultProps = {
    handleSubmitSuccess : (results,dispatch,props) => {}
};

class CompanyContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {view : 0};
    }

    swapView = (index) => {
        this.setState({view:index});
    };


    GetComponentHandler = (parent) => {

        return  {
            handleSubmit: (values, dispatch, props) => {
                dispatch(Errors.clear());
                return UserProfile(parent.props.config.userprof).user(props.registration.colleague.username).Summary.Get().then(
                    () => {

                    },
                    (reason) => {
                        if(reason.status >= 500 || reason.status === 0){
                            throw new SubmissionError({ _error : reason , status : reason.status } )
                        }
                        else {
                            throw new SubmissionError( { _error : "Form submission invalid" })
                        }
                    }
                )
            },

            handleSubmitSuccess: (result, dispatch, props) => {
                parent.swapView(1);
            },

            handleSubmitFail: (errors, dispatch, submitErrors, props) => {
                if(submitErrors || errors){
                    if(submitErrors && ( submitErrors.errors.status === 0 || submitErrors.errors.status >= 500) ){
                        dispatch(Errors.TechnicalError())
                    }
                    else if(submitErrors && submitErrors.errors && submitErrors.errors.status >= 400){
                        dispatch(Errors.InvalidFormSubmission());
                    }
                    else if(errors){
                        const keys = flattenObject(errors);
                        dispatch(Errors.InvalidFormSubmission(Object.keys(keys).map((i) => {return ( <li>{keys[i]}<Link to={props.path + "#" + i}  >..</Link></li> )})))
                    }
                }
            }
        };
    };

    ViewComponentHandler = (parent) => {
        return {
            handleSubmit: (data, dispatch, props) => {

                dispatch(Errors.clear());
                return UserRegistration(props.config.userreg).Create(props.registration)
                    .then(
                        () => { } ,
                        (error) => {
                            if(error.status === 0 || error.status >= 400 ){
                                throw new SubmissionError( { status : error.status })
                            }
                            else{
                                throw new SubmissionError( { _error : error.message })
                            }
                        })
            },
            handleSubmitFail: (errors, dispatch, submitErrors, props) => {
                AnalyticEvent(window.dataLayer,{
                    "eventInfo": {
                        "eventName": "registrationFailed",
                    }
                }).then(() => {
                    DirectCall(window._satellite, "registrationFailed")
                }, ()=> {});
                if(submitErrors || errors){
                    if(submitErrors && ( submitErrors.errors.status === 0 || submitErrors.errors.status >= 500) ){
                        dispatch(Errors.TechnicalError())
                    }
                    else if(submitErrors && submitErrors.errors && submitErrors.errors.status >= 400){
                        dispatch(Errors.InvalidFormSubmission());
                    }
                    else if(errors){
                        dispatch(Errors.InvalidFormSubmission())
                    }
                }
            }
        }
    };

    render = () => {

        const props = this.props;
        const views = [
            <ScrollToGetComponent key={1}
                          redirectToNoAccount={() => {
                              this.props.dispatch(change('registration' , 'hasaccount' , {value:false, label:"No I don't think we do"} ));
                              this.props.handleRedirectToNoAccount();
                          }}
                          path={this.props.path}
                          onSubmit={this.GetComponentHandler(this).handleSubmit}
                          onSubmitSuccess={this.GetComponentHandler(this).handleSubmitSuccess}
                          onSubmitFail={this.GetComponentHandler(this).handleSubmitFail}
                          validate={(values,dispatch) => {
                              return Validators.ExistingAccount.validate(values);
                          }}

            />,


            <ScrollToViewComponent key={2}
                           path={props.path}
                           onSubmitFail={this.ViewComponentHandler(this).handleSubmitFail}
                           onSubmitSuccess={(result,dispatch,props) => {
                               AnalyticEvent(window.dataLayer, {
                                   "eventInfo": {
                                       "eventName":"registrationStep4",
                                       "eventAction": "2",
                                   },
                                   "attributes": {
                                       "shippingType": "Outside Australia",
                                       "customerType": "My self",
                                       "existingCompanyAccount": "Yes"
                                   }
                               }).then(() => {
                                    DirectCall(window._satellite, "lookupCustomerDetails")
                                }, ()=> {});
                               this.props.handleSubmitSuccess(result,dispatch,props);
                           }}
                           onSubmit={this.ViewComponentHandler(this).handleSubmit}
                           back={() => { this.swapView(0)} }

            />
        ];

        return views[this.state.view]
    }
}


CompanyContainer = connect(state => {

    let company = getFormValues('existingcompany')(state);

    return {
        config : getFormValues('config')(state),
        'existingcompany': company ,
    }

})(CompanyContainer);

export {
    CompanyContainer
}
